/**
 * Created by hp on 2017/8/14.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import giftBar from '../../images/index-gift-hf.png';

class MainGiftBar extends Component {
    constructor() {
        super();
        this.handleOpenGiftPopup = this.handleOpenGiftPopup.bind(this);
    }

    handleOpenGiftPopup() {
        this.props.dispatch({type: 'MAIN_SHOW_GIFT_POPUP'});
    }

    render() {
        const {giftPopupShow, account} = this.props;

        if (giftPopupShow) {
            return null;
        }

        if (!account.can_receive_gift) {
            return null;
        }

        return (
            <div className="main-gift-bar" onClick={this.handleOpenGiftPopup}>
                <img src={giftBar}/>
            </div>
        )
    }
}

export default connect((state) => ({
    giftPopupShow: state.main.giftPopupShow,
    account: state.main.account,
}))(MainGiftBar)


// WEBPACK FOOTER //
// ./src/components/main/MainGiftBar.js